export const instantAppId = "38695e7e-368c-49d5-8630-26b271f02d1f";
export const posthogId = "phc_tQ9334EGu96ZEIYzrGPzk1X9VquSqSS6GrAJrXIIAWI";
